import { getI18n, useTranslation } from "react-i18next";

export function useLanguage() {
	const i18n = getI18n();
	const { t } = useTranslation();

	const changeLanguage = (value: string) => {
		i18n.changeLanguage(value);
		localStorage.setItem("language", value);
		window.location.reload();
	};

	const language = i18n ? i18n.language : "es";

	return { language, changeLanguage, t };
}
